module.exports = __webpack_public_path__ + "images/mmm-faq-05-desktop.png";